import { render, staticRenderFns } from "./businessTemplate.vue?vue&type=template&id=28fc5615&scoped=true&"
import script from "./businessTemplate.vue?vue&type=script&lang=js&"
export * from "./businessTemplate.vue?vue&type=script&lang=js&"
import style0 from "./businessTemplate.vue?vue&type=style&index=0&id=28fc5615&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fc5615",
  null
  
)

export default component.exports